var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-menu-layout',[_c('row12',[_c('row12',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.add.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('settings_tasks.btn_create')))])],1),_c('task-list',{attrs:{"tasks":_vm.tasks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }